import PropsTypes from 'prop-types';
import React from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faAngleDown, faAngleUp} from '@fortawesome/free-solid-svg-icons'

export default class MapNameNavigator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {value: props.selectedMap, showMenu: false};
        this.selectMap = this.selectMap.bind(this);
        this.showMenu = this.showMenu.bind(this);
        this.hideMenu = this.hideMenu.bind(this);
    }

    selectMap(map) {
        this.setState({value: map, showMenu: false});
        this.props.onSelection(map);
    }

    showMenu(event) {
        event.preventDefault();
        this.setState({showMenu: true});
    }

    hideMenu(event) {
        event.preventDefault();
        this.setState({showMenu: false});
    }

    componentDidUpdate(_, __, ___) {
        if (this.props.selectedMap !== this.state.value) {
            this.setState({value: this.props.selectedMap, showMenu: false});
        }
    }

    render() {
        return (
            <div className="nameOverlay" onClick={this.state.showMenu ? this.hideMenu : this.showMenu}>
                <FontAwesomeIcon icon={this.state.showMenu ? faAngleUp : faAngleDown}/>
                <div>{this.state.value['NAME']}</div>
                {
                    this.state.showMenu ?
                        (<ul>
                            {this.props.maps
                                .map((map) => {
                                    return (
                                        <li key={map.ID} onClick={() => {
                                            this.selectMap(map);
                                        }}>
                                            {map['NAME']}
                                        </li>
                                    )
                                })}

                        </ul>)
                        : null
                }
            </div>
        );
    }
}

MapNameNavigator.propTypes = {
    maps: PropsTypes.array.isRequired,
    selectedMap: PropsTypes.any.isRequired,
    onSelection: PropsTypes.func.isRequired,
};
